export default "__VITE_ASSET__B1VO_Kc8__"